import { render, staticRenderFns } from "./ToBePickedUp.vue?vue&type=template&id=17b671ad&"
import script from "./ToBePickedUp.vue?vue&type=script&lang=ts&"
export * from "./ToBePickedUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports